module.exports = __webpack_public_path__ + "static/media/OutReaching.Space.864b71e8.svg";